import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorsService } from '@perval/shared';
import { format } from 'date-fns';
import { ExportConsumptionTrackingCsvService } from '../../services/export-consumption-tracking-csv.service';

@Component({
  selector: 'admin-export-consumption-tracking-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './export-consumption-tracking-form.component.html',
  styleUrls: ['./export-consumption-tracking-form.component.scss'],
})
export class ExportConsumptionTrackingFormComponent implements OnInit {
  today: Date = new Date();
  minStartDate: Date = new Date(
    new Date().setFullYear(this.today.getFullYear() - 1),
  );

  readonly dateRangeForm = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  errorMessage!: string;
  infoMessage!: string;

  constructor(
    private readonly exportConsumptionTrackingCsvService: ExportConsumptionTrackingCsvService,
    private readonly errorsService: ErrorsService,
  ) {}

  get isRangeSelected(): boolean {
    return (
      !this.dateRangeForm.controls.end.value ||
      !this.dateRangeForm.controls.start.value
    );
  }

  ngOnInit(): void {}

  async export(): Promise<void> {
    this.resetMessages();

    try {
      const startedDate = this.dateRangeForm.controls.start.value as Date;
      const endedDate =
        this.dateRangeForm.controls.end.value &&
        this.dateRangeForm.controls.end.value.getTime() <= Date.now()
          ? (this.dateRangeForm.controls.end.value as Date)
          : new Date();
      const result =
        await this.exportConsumptionTrackingCsvService.exportConsumptionTrackingCsv(
          startedDate,
          endedDate,
        );

      if (result instanceof Blob) {
        const url = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = url;
        link.download = `stats_utilisation_${format(startedDate, 'yyyyMMdd')}_${format(endedDate, 'yyyyMMdd')}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.infoMessage = 'Le fichier a été téléchargé';
      } else {
        this.infoMessage = result;
      }
      // TODO : gérer les erreurs correctement dans NPER-812
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      this.errorMessage = this.errorsService.getError((error as Error).message);
    }
  }

  private resetMessages(): void {
    this.errorMessage = '';
    this.infoMessage = '';
  }
}
